// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Rm9D","field":"styles_field__2F_cj","fieldCol":"styles_fieldCol__1mleA","diffCol":"styles_diffCol__gLYW9","diff":"styles_diff__1y45D"};